import { ReservationManager } from '../ReservationManager';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class ReservationManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers = {}) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/reservation`, headers);
  }

  createReservationManager(token: string): ReservationManager {
    return new ReservationManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
